import {useRefInfo} from '../../contexts/RefInfoContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {repositoryTreePath} from '@github-ui/paths'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {HourglassIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {memo} from 'react'

import {SharedMarkdownContent} from '../SharedMarkdownContent'

import styles from './DirectoryRichtextContent.module.css'

export const DirectoryRichtextContent = memo(function DirectoryRichtextContentComponent({
  errorMessage,
  path,
  richText,
  stickyHeaderHeight,
  timedOut,
}: {
  errorMessage?: string
  path: string
  richText: SafeHTMLString | null
  stickyHeaderHeight?: number
  timedOut?: boolean
}) {
  const repo = useCurrentRepository()
  const refInfo = useRefInfo()
  if (errorMessage) {
    return (
      <div className="tmp-py-6 tmp-px-3 text-center">
        {timedOut && <HourglassIcon size={32} />}
        <div data-testid="directory-richtext-error-message">{errorMessage}</div>
        {timedOut && (
          <div>
            But you can view the{' '}
            <Link
              inline
              href={repositoryTreePath({repo, commitish: refInfo.name, action: 'raw', path})}
              data-testid="directory-richtext-timeout-raw-link"
            >
              raw file
            </Link>
            .
          </div>
        )}
      </div>
    )
  } else if (richText) {
    return (
      <SharedMarkdownContent
        richText={richText}
        stickyHeaderHeight={stickyHeaderHeight}
        suppressHydrationWarning
        className={styles.SharedMarkdownContent}
      />
    )
  }
  return null
})
